import actionTypes from '../../actions/bill/partSettle/actionType';

const defaultPartSettleInfo = {
  consumeAmount: 0, // 已消费金额
  ota: 0, // OTA预付款
  payAmount: 0, // 已付款金额
  settleAmount: 0, // <0 应付房费，=0 确认结账，>0 应退房费
};

const initialState = {
  drawerVisible: false,
  infoLoading: false,
  partSettleInfo: defaultPartSettleInfo, // 部分结账金额信息
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_PART_SETTLE_DRAWER_VISIBLE:
      const { drawerVisible } = payload;
      return {
        ...state,
        drawerVisible,
      };

    case actionTypes.SET_PART_SETTLE_INFO_LOADING:
      const { infoLoading } = payload;
      return {
        ...state,
        infoLoading,
      };
    case actionTypes.FETCH_PART_SETTLE_INFO:
      const { partSettleInfo } = payload;
      return {
        ...state,
        partSettleInfo,
      };
    case actionTypes.RESET_PART_SETTLE_INFO:
      return {
        ...state,
        partSettleInfo: defaultPartSettleInfo,
      };
    default:
      return state;
  }
};
